import {Box, Stack, useTheme} from "@mui/joy";
import {VenueCapsule} from "../venue/capsule.tsx";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faFlagCheckered} from "@fortawesome/pro-regular-svg-icons";
import {Bundle, watchBundleByIdTqo} from "../rpc/webrpc-client.gen.ts";
import {useQuery} from "@tanstack/react-query";
import {useMemo} from "react";
import {ActionButton} from "../components/ActionButton.tsx";
import {BundleTile, BundleTileProps, useBundlePickupPlaceCapsule} from "../bundle/tile.tsx";
import {JoyableProps} from "../components/Tile.tsx";
import {useTranslation} from "react-i18next";
import {useBundleActions} from "../bundle/bundle.tsx";
import {BundleStatus, BundleStatusCode, bundleStatusCodeLabelKeys, useBundleStatus} from "../bundle/status.tsx";
import {useMothership} from "../tq/tqx.tsx";

//
// export function useDriverBundleStatus({bundleId, enabled, ...rest}: LimitedUseQueryOptions<{
//     bundleId: string
// }>): LimitedUseQueryResult<BundleStatus> {
//     const {data: self}
//         = useQuery(getSelfIdentityTqo);
//     const {data: bundleData, isSuccess: isBundleSuccess}
//         = useRefreshableQuery({...activeBundleByIdTqo({id: bundleId}), enabled, ...rest});
//     const bundle = isBundleSuccess ? bundleData.bundle : undefined;
//     const {data: lastTransferData, isSuccess: isLastTransferSuccess}
//         = useRefreshableQuery({...lastTransferForBundleTqo({bundleId}), enabled, ...rest});
//     const lastTransfer = isLastTransferSuccess ? lastTransferData.transfer : undefined;
//     const {data: fieldApprovalData, isSuccess: isFieldApprovedSuccess}
//         = useFlavoredBundleStamp({
//         bundleId, flavor: BundleStampFlavor.FIELD_COMPLETE_ACCEPT,
//         enabled, ...rest
//     });
//     const fieldApproval = fieldApprovalData?.stamp;
//     const isFieldApproved = !!fieldApproval;
//     const {data: deliveryStampData, isSuccess: isDeliveredSuccess}
//         = useFlavoredBundleStamp({
//         bundleId, flavor: BundleStampFlavor.DELIVERED,
//         enabled, ...rest
//     });
//     const deliveryStamp = deliveryStampData?.stamp;
//     const isDelivered = !!deliveryStamp;
//
//     const {data: mountedTruckData, isSuccess: isMountedTruckSuccess}
//         = useMountedTruck({enabled, ...rest});
//     const mountedTruck = isMountedTruckSuccess ? mountedTruckData.truck : undefined;
//     const mountedTruckId = mountedTruck?.id ?? TQDEADBEEF;
//     const {data: myTruckStatus, isSuccess: isMyTruckStatusSuccess}
//         = useTruckStatus({
//         truckId: mountedTruckId,
//         enabled: (enabled ?? true) && mountedTruckId !== TQDEADBEEF,
//         ...rest
//     });
//
//     const {data: scheduledTransferData, isSuccess: isScheduledTransferSuccess}
//         = useRefreshableQuery({...scheduledTransferForBundleTqo({bundleId}), enabled, ...rest});
//     const scheduledTransfer = isScheduledTransferSuccess ? scheduledTransferData.scheduledTransfer : undefined;
//     const navigate = useNavigate();
//
//     const navigateToMyTruckCargo = useCallback(() => {
//         if (mountedTruck) {
//             return navigate({
//                 to: truckRoute.to,
//                 params: {id: mountedTruckId},
//                 search: {facet: "cargo"},
//             });
//         } else {
//             return Promise.resolve();
//         }
//     }, [mountedTruck, mountedTruckId, navigate]);
//
//     const {t} = useTranslation();
//     const codeLabels = useMemo<Record<BundleStatusCode, string>>(() => {
//         return {
//             [BundleStatusCode.enum.UNKNOWN]: t("unknown"),
//             [BundleStatusCode.enum.AWAITING_PICKUP]: t("driver.awaitingOnload"),
//             [BundleStatusCode.enum.ONLOADING]: t("driver.onloading"),
//             [BundleStatusCode.enum.ONLOADED]: t("onloaded"),
//             [BundleStatusCode.enum.FIELD_APPROVED]: t("fieldApproved"),
//             [BundleStatusCode.enum.DELIVERED]: t("delivered"),
//         };
//     }, [t]);
//
//     const {mutateAsync: startOnloading}
//         = useMutation(startBundleOnloadingTqmo);
//     const performStartOnloading = useCallback(() => {
//         if (mountedTruckId === TQDEADBEEF) {
//             throw new Error("ghost truck onloading");
//         }
//         return startOnloading({
//             bundleId, truckId: mountedTruckId
//         }).then(() => navigate({
//             to: bundleRoute.to,
//             params: {id: bundleId},
//             search: {facet: "cargo"},
//         }))
//     }, [bundleId, mountedTruckId, navigate, startOnloading]);
//
//     const {mutateAsync: sendStampBundle}
//         = useMutation(stampBundleTqmo);
//
//     const makeFieldProposalStamp = useCallback(() => ({
//         bundleId,
//         flavor: BundleStampFlavor.FIELD_COMPLETE_PROPOSE,
//     }), [bundleId]);
//     const {mutateAsync: sendCompleteOnloading}
//         = useMutation(completeBundleOnloadingTqmo);
//     const completeOnloading = useCallback(() =>
//         sendCompleteOnloading({bundleId}), [bundleId, sendCompleteOnloading]);
//
// //    const offloadVenueId = lastTransfer?.offloadVenue?.id ?? bundle?.destination?.id ?? TQDEADBEEF;
//     const {mutateAsync: performCompleteOffloading}
//         = useMutation(completeBundleOffloadingTqmo);
//     const completeOffloading = useCallback(() => performCompleteOffloading({bundleId}),
//         [bundleId, performCompleteOffloading]);
//     const startTripleg = useTriplegStarter();
//     const stampDelivered = useCallback(() => sendStampBundle({
//         bundleId,
//         flavor: BundleStampFlavor.DELIVERED,
//     }), [bundleId, sendStampBundle]);
//
//     const isMyBundle = (mountedTruck?.id === lastTransfer?.truck.id) ||
//         (self?.id === scheduledTransfer?.driver?.id);
//
//     if (!isMountedTruckSuccess || !isFieldApprovedSuccess || !isDeliveredSuccess
//         || (!!mountedTruck && !isMyTruckStatusSuccess)
//         || !isBundleSuccess || !isScheduledTransferSuccess
//         || !isLastTransferSuccess) {
//         return {isSuccess: false};
//     }
//
//     let unlabeledRv: Omit<BundleStatus, "label">;
//     if (!bundle) {
//         unlabeledRv = {code: BundleStatusCode.enum.UNKNOWN};
//     } else if (isDelivered) {
//         unlabeledRv = {
//             code: BundleStatusCode.enum.DELIVERED, place: {venue: bundle.destination},
//         };
//     } else if (!!mountedTruck && !!myTruckStatus) {
//         if (!lastTransfer) {
//             unlabeledRv = {
//                 code: BundleStatusCode.enum.AWAITING_PICKUP, place: bundle.origin,
//                 ...(isMyBundle && myTruckStatus.currentPlace?.id === bundle.origin.venue?.id
//                     ? {
//                         nextStepName: t("driver.startOnloading"),
//                         takeNextStep: () => startOnloading({
//                             bundleId, truckId: mountedTruck.id
//                         }).then(() => navigate({
//                             to: bundleRoute.to,
//                             params: {id: bundleId},
//                             search: {facet: "cargo"},
//                         })),
//                     }
//                     : {}),
//             };
//         } else if (isTstzFinite(lastTransfer.offloadEnded)) {
//             unlabeledRv = {code: BundleStatusCode.enum.DELIVERED, place: {venue: lastTransfer.offloadVenue}};
//         } else if (isTstzFinite(lastTransfer.onloadStarted) && !isTstzFinite(lastTransfer.onloadEnded)) {
//             unlabeledRv = {
//                 code: BundleStatusCode.enum.ONLOADING, place: {venue: lastTransfer.onloadVenue},
//                 ...(isMyBundle
//                     ? {
//                         nextStepName: t("driver.completeOnload"),
//                         takeNextStep: () => completeOnloading()
//                             .then(() => makeFieldProposalStamp()),
//                     }
//                     : {}),
//             };
//         } else if (isFieldApproved) {
//             if (myTruckStatus?.currentPlace?.id !== bundle.destination?.id) {
//                 unlabeledRv = {
//                     code: BundleStatusCode.enum.FIELD_APPROVED, place: {truck: lastTransfer.truck},
//                     ...(isMyBundle && myTruckStatus.canDepart
//                         ? {
//                             nextStepName: t("driver.depart"),
//                             takeNextStep: () => {
//                                 if (bundle.destination?.id) {
//                                     return startTripleg(bundle.destination.id);
//                                 } else {
//                                     return Promise.reject(new Error("nothing to do"));
//                                 }
//                             },
//                         }
//                         : {}),
//                 }
//             } else {
//                 unlabeledRv = {
//                     code: BundleStatusCode.enum.FIELD_APPROVED, place: {truck: lastTransfer.truck},
//                     ...(isMyBundle && myTruckStatus.currentPlace?.id === bundle.destination?.id
//                         ? {
//                             nextStepName: t("driver.offload"),
//                             takeNextStep: () => completeOffloading()
//                                 .then(() => stampDelivered())
//                                 .then(() => navigateToMyTruckCargo())
//                         }
//                         : {})
//                 };
//             }
//         } else {
//             unlabeledRv = {
//                 code: BundleStatusCode.enum.ONLOADED, place: {truck: lastTransfer.truck},
//                 ...(isMyBundle
//                     ? {
//                         nextStepName: t("driver.seekFieldApproval"),
//                         takeNextStep: () => navigate({
//                             to: bundleRoute.to,
//                             params: {id: bundleId},
//                             search: {facet: "cargo"},
//                         }),
//                     } : {}),
//             };
//         }
//     } else {
//         unlabeledRv = {code: BundleStatusCode.enum.UNKNOWN};
//     }
//
//     const labeledRv = {...unlabeledRv, label: codeLabels[unlabeledRv.code]};
//
//     return {isSuccess: true, data: labeledRv};
// }

export function useBundleDestinationCapsule(bundle: Bundle | undefined) {
    return bundle?.destination
        ? <Stack direction="row" spacing={1.8} sx={{alignItems: "center"}}>
            <FontAwesomeIcon icon={faFlagCheckered}/>
            <VenueCapsule venue={bundle.destination}/>
        </Stack>
        : null;
}

export function joyifyBundleStatus(status?: BundleStatus): JoyableProps {
    switch (status?.code) {
        case BundleStatusCode.enum.UNKNOWN:
            return {color: "danger", variant: "solid"};
        case BundleStatusCode.enum.AWAITING_PICKUP:
            return {color: "warning", variant: "outlined"};
        case BundleStatusCode.enum.ONLOADING:
            return {color: "primary", variant: "soft"};
        case BundleStatusCode.enum.ONLOADED:
            return {color: "primary", variant: "soft"};
        case BundleStatusCode.enum.FIELD_APPROVED:
            return {color: "success", variant: "outlined"};
        case BundleStatusCode.enum.OFFLOADING:
            return {color: "primary", variant: "soft"};
        case BundleStatusCode.enum.DELIVERED:
            return {color: "neutral", variant: "outlined"};
        case BundleStatusCode.enum.INACTIVE:
            return {color: "neutral", variant: "outlined"};
        case BundleStatusCode.enum.INSPECTED:
            return {color: "neutral", variant: "outlined"};
        case undefined:
            return {color: "neutral", variant: "outlined"};
    }
}

export function DriverBundleTile(props: BundleTileProps) {
    const {
        bundleStub,
        color: inColor,
        variant: inVariant,
        ...rest
    } = props;
    const theme = useTheme();
    const {t} = useTranslation();
    const mama = useMothership();
    const bundleId = bundleStub.id;
    const bundleTqrv = useQuery(watchBundleByIdTqo(mama, {bundleId}));
    const bundle = bundleTqrv.data;
    const pickupPlaceCapsule = useBundlePickupPlaceCapsule({bundle});
    const destinationCapsule = useBundleDestinationCapsule(bundle);
    const {data: status} = useBundleStatus({bundleId});
    const cosmetics: JoyableProps = joyifyBundleStatus(status);
    const color = inColor ?? cosmetics.color;
    const variant = inVariant ?? cosmetics.variant;
    const actionProps = useBundleActions({bundleId});
    const actions = useMemo(() => {
        if (!actionProps.data) {
            return null;
        }
        return <>
            {actionProps.data.map(kap =>
                <ActionButton size="lg" key={kap.key} {...kap.elem}/>)}
        </>
    }, [actionProps]);

    return <BundleTile bundleStub={bundleStub} linkify={true}
                       color={color} variant={variant}
                       actions={actions} {...rest}>
        {pickupPlaceCapsule}
        {destinationCapsule}
        {status
            ? <Box sx={{fontSize: theme.fontSize.lg, mt: 1}}>{t(bundleStatusCodeLabelKeys[status.code])}</Box>
            : null}
    </BundleTile>
}

